import { createContext as t, useContext as r } from "react";
const e = t(null), o = () => {
  const t2 = r(e);
  if (!t2) throw new Error("usePermissionsContext must be used within a PermissionsContext");
  return t2;
};
export {
  e as PermissionsContext,
  o as usePermissionsContext
};
//# sourceMappingURL=usePermissionsContext.js.map
